<div class="floatLabel registro" [ngClass]="{'soloLectura' : disabled}">

  <div class="dropdown select" [ngClass]="{'is-filled' : hora, 'margenControl' : margenControl }" dropdown id="ddDatosOpciones" #dropdown>

    <!-- Menu -->
    <ul class="dropdown-menu" aria-labelledby="ddTimePicker" style="width: 100%"  id="ddTimePicker{{id}}" (click)="EvitarCierre()">
      <ngb-timepicker class="timePicker" [(ngModel)]="hora" [meridian]="meridiano" mode (ngModelChange)="NuevaHora()"></ngb-timepicker>
    </ul>

    <!-- Botón -->
    <div class="btnDropdown ddSelect ddPicker" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" tabindex="0" id="ddBoton{{id}}" (keypress)="TeclaPresionada($event)">

      <!-- dato seleccionado -->
      <div class="texto">
        {{valor ? (('01/01/1991 ' + valor) | date : (meridiano ? 'hh:mm a' : 'HH:mm')) : ''}}
      </div>

      <!-- Limpiar control -->
      <div class="btnTimes dropdownTimes btnEliminarHora" *ngIf="limpiarInput && !disabled  && hora" (click)="LimpiarValor()">
        <span class="fa fa-times"></span>
      </div>

    </div>

    <!-- Mensaje error -->
    <span *ngIf="verError" class="textoError" [hidden]="hora || !errorActivo">
      {{(mensajeError ? mensajeError : 'DatoIncompeto') | translate}}
    </span>

  </div>

  <!-- Label (título del control) -->
  <label>{{titulo}}</label>

</div>
